import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, ExternalLink } from 'lucide-react';
import { projects } from '../mock';

const Projects = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextProject = () => {
    setCurrentIndex((prev) => (prev + 1) % projects.length);
  };

  const prevProject = () => {
    setCurrentIndex((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const currentProject = projects[currentIndex];

  return (
    <section id="projects" className="section-large bg-dark">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Project Showcase
          </h2>
          <div className="w-20 h-1 bg-accent-teal mx-auto mb-6"></div>
          <p className="text-lg text-neutral-silver max-w-2xl mx-auto">
            Explore some of our recent work and see how we bring ideas to life
          </p>
        </div>

        {/* Carousel */}
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden bg-accent-violet/10 border border-accent-violet/30">
            {/* Project Media (Image or Video) */}
            <div className="aspect-video w-full overflow-hidden">
              {currentProject.type === 'video' ? (
                <video
                  src={currentProject.media}
                  className="w-full h-full object-cover"
                  controls
                  loop
                  muted
                  autoPlay
                />
              ) : (
                <img
                  src={currentProject.image}
                  alt={currentProject.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
              )}
            </div>

            {/* Project Info - Hidden on mobile */}
            <div className="hidden md:block p-8 bg-gradient-to-t from-black/90 to-transparent absolute bottom-0 left-0 right-0">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <span className="inline-block px-3 py-1 bg-white rounded-full text-accent-teal text-sm font-medium mb-3">
                    {currentProject.category}
                  </span>
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                    {currentProject.title}
                  </h3>
                  <p className="text-neutral-silver">{currentProject.description}</p>
                </div>
                <button 
                  className="flex-shrink-0 w-12 h-12 rounded-full bg-accent-teal/10 border border-accent-teal/30 flex items-center justify-center opacity-50 cursor-not-allowed"
                  disabled
                  title="Link coming soon"
                >
                  <ExternalLink size={20} className="text-accent-teal" />
                </button>
              </div>
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={prevProject}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm border border-white/20 flex items-center justify-center hover:bg-black/70 transition-all"
            >
              <ChevronLeft size={24} className="text-white" />
            </button>
            <button
              onClick={nextProject}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm border border-white/20 flex items-center justify-center hover:bg-black/70 transition-all"
            >
              <ChevronRight size={24} className="text-white" />
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex items-center justify-center gap-2 mt-8">
            {projects.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all ${
                  index === currentIndex
                    ? 'w-8 bg-accent-teal'
                    : 'w-2 bg-neutral-silver/30 hover:bg-neutral-silver/50'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
